var _path, _path2, _path3, _ellipse, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyStateAppointmentsFuture(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 68,
    viewBox: "0 0 72 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.06641 20.1348H70.2664V58.5348C70.2664 62.6585 66.9235 66.0014 62.7997 66.0014H10.5331C6.40935 66.0014 3.06641 62.6585 3.06641 58.5348V20.1348Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.06641 20.1348H70.2664V12.6681C70.2664 8.54438 66.9235 5.20143 62.7997 5.20143H10.5331C6.40935 5.20143 3.06641 8.54437 3.06641 12.6681V20.1348Z",
    fill: "#F0FBFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5556 5.0129C64.7871 5.0129 64.2584 5.00224 65.8746 5.8333C67.2963 6.56432 68.4521 7.73077 69.1765 9.16547C69.6541 10.1114 70 12.2215 70 13.9622V16.8594V38.801V54.0542C70 58.2359 70 60.3268 69.1862 61.924C68.4703 63.329 67.3281 64.4712 65.9231 65.1871C64.3259 66.0009 62.2351 66.0009 58.0533 66.0009H47.1563H14.0889C9.85738 66.0009 7.74163 66.0009 6.12541 65.1698C4.70374 64.4388 3.54788 63.2724 2.82351 61.8377C2 60.2066 2 58.0715 2 53.8012V17.202C2 12.9317 2 10.7965 2.82351 9.16547C3.54788 7.73077 4.70374 6.56432 6.12541 5.8333C7.36331 5.19677 8.89425 5.04777 11.4444 5.0129M18.156 2.00098V5.0129V7.84127M55.2908 2.00098V5.0129V7.84127M2 20.2519C23.8346 20.2519 37.0091 20.1343 58.8438 20.1343M49.5035 5.0129H23.9433",
    stroke: "#00A4BF",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.8016,
    cy: 39.3842,
    rx: 7.2,
    ry: 7.16256,
    fill: "#F0FBFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5942 44.0088L44.5 48.9339M41.6667 38.9783C41.6667 42.9057 38.4953 46.0894 34.5833 46.0894C30.6713 46.0894 27.5 42.9057 27.5 38.9783C27.5 35.0509 30.6713 31.8672 34.5833 31.8672C38.4953 31.8672 41.6667 35.0509 41.6667 38.9783Z",
    stroke: "#00A4BF",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.625 20.1348H65.5113",
    stroke: "#00A4BF",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateAppointmentsFuture);
export default __webpack_public_path__ + "static/media/empty-state-appointments-future.999b07498e9a89546c7c45e1621c3d93.svg";
export { ForwardRef as ReactComponent };